export default __webpack_public_path__ + "static/media/saw-logo-corrected.083293c9.svg";